// "Scene reel" identity pill for AdThumbnail.
//
// Same visual language as the Master pill (solid, rounded, bottom-left) because
// it answers the same question — WHAT this ad is, not where it is in the
// pipeline — and it takes the Master pill's corner on a scene-reel ad. A scene
// reel's 9:16 is the plate its 1:1 is cropped from, but it is not an Omni
// video plate, so the generic Master wording would mislead; the tooltip says
// what the reel actually is. The pipeline/failure state stays on the top-right
// status badge; a failed scene is named in the tooltip only.
import { Badge } from '@chakra-ui/react';
import { sceneReelBadgeTitle, type SceneReelSummary } from '../../lib/sceneReel';

export function SceneReelBadge({
  summary,
  position
}: {
  summary:   SceneReelSummary | null | undefined;
  position?: { bottom?: number; left?: number };
}) {
  return (
    <Badge
      position={position ? 'absolute' : undefined}
      bottom={position?.bottom}
      left={position?.left}
      colorScheme="pink"
      variant="solid"
      fontSize="8px"
      px={1.5}
      py={0.5}
      borderRadius="full"
      textTransform="uppercase"
      letterSpacing="0.04em"
      title={sceneReelBadgeTitle(summary)}
    >
      {summary?.role === 'derive' ? 'Scene reel · 1:1' : 'Scene reel'}
    </Badge>
  );
}
